import { useEffect, useRef } from 'react';
import styles from './Grain.module.css';

const TILE_SIZE = 160;
const GRAIN_ALPHA = 34;

function createGrainTile(): string {
    const canvas = document.createElement('canvas');
    canvas.width = TILE_SIZE;
    canvas.height = TILE_SIZE;
    const context = canvas.getContext('2d');
    if (!context) return '';
    const image = context.createImageData(TILE_SIZE, TILE_SIZE);
    for (let offset = 0; offset < image.data.length; offset += 4) {
        const value = Math.random() * 255;
        image.data[offset] = value;
        image.data[offset + 1] = value;
        image.data[offset + 2] = value;
        image.data[offset + 3] = GRAIN_ALPHA;
    }
    context.putImageData(image, 0, 0);
    return canvas.toDataURL('image/png');
}

export default function Grain() {
    const layerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const tile = createGrainTile();
        if (tile && layerRef.current) {
            layerRef.current.style.backgroundImage = `url(${tile})`;
        }
    }, []);

    return <div ref={layerRef} className={styles.grain} aria-hidden="true" />;
}
